import { render, staticRenderFns } from "./PeerGroupRoleFilterControl.vue?vue&type=template&id=bfb490d2&"
import script from "./PeerGroupRoleFilterControl.vue?vue&type=script&lang=ts&"
export * from "./PeerGroupRoleFilterControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports